import moment from "moment";
import { v4 as uuidv4 } from 'uuid';
import { cloneDeep } from "lodash";
import useDatabaseAPI, { DealBuilderSavedFormat } from "../../pricing-management/hooks/useDatabaseAPI.ts";
import Result from "../utils/result.utils.ts";
import usePricingManagementStore from "../../stores/pricing-management.store.ts";
import useDealBuilderResultStore from "../../stores/deal-builder-result.store.ts";
import { DealStatus, DealBuilder } from "../services/deal-builder.ts";

export default function useDealBuilderSaver() {
  const { savedDeals, setSavedDeals } = usePricingManagementStore();
  const { DealBuilderService, setDealBuilderService } = useDealBuilderResultStore();
  const { upsertDeal, toSavedFormat, fromSavedFormat, deleteDeal } = useDatabaseAPI();

  async function saveDealAsNew(dealBuilder: DealBuilder, status: DealStatus): Promise<DealBuilder> {
    const newDeal = cloneDeep(dealBuilder);
    newDeal.savedDate = moment();
    newDeal.dealId = uuidv4();
    newDeal.dealStatus = status;
    const savedFormat = toSavedFormat(newDeal);
    await upsertDeal(savedFormat);
    return newDeal;
  }

  async function updateSavedDeal(savedDeal: DealBuilderSavedFormat): Promise<Result<undefined>> {
    setSavedDeals([
      ...savedDeals.filter(x => x.deal_id !== savedDeal.deal_id),
      savedDeal
    ]);

    if (DealBuilderService && savedDeal.deal_id === DealBuilderService.dealId) {
      const deal = await fromSavedFormat(savedDeal);
      setDealBuilderService(deal);
    }

    return upsertDeal(savedDeal);
  }

  function deleteSavedDeal(savedDeal: DealBuilderSavedFormat): Promise<Result<undefined>> {
    setSavedDeals([
      ...savedDeals.filter((x) => x.deal_id !== savedDeal.deal_id),
    ]);

    // Delete from the database
    return deleteDeal(savedDeal.deal_id);
  }

  return { saveDealAsNew, updateSavedDeal, deleteSavedDeal };
}
